import { useEffect, useMemo, useState } from 'react';

import brandLogo from '../../../assets/logo.svg';
import BorderBlackFridayImage from '../../../assets/border-black-friday.svg';
import { MLABS_TRANSLATOR_ON_CHANGE_LANGUAGE } from '../../../constants';
import api from '../../../services/api';
import { getLanguage } from '../../../services/auth';
import { transcodeLanguage } from '../../../utils/language';
import bannerBlackFridayData from './banner-black-friday.json';
import useCore from '../../../hooks/useCore';

import {
  ImageContainer,
  BannerImage,
  BannerWrapper,
  ContainerTexts,
  Title,
  Disclaimer,
  AnimationContainer,
  AnimationCircle,
  BorderBlackFriday,
} from './styles';

const BlackFriday = () => {
  const [language, setLanguage] = useState('pt-BR');
  const [blackFriday, setBlackFriday] = useState(null);
  const [featureIsActive, setFeatureIsActive] = useState(false);
  const { fetchFeature } = useCore();
  const currentLanguage = getLanguage();

  window.addEventListener(MLABS_TRANSLATOR_ON_CHANGE_LANGUAGE, (event) => {
    setLanguage(transcodeLanguage(event.detail.language));
  });

  const getBlackFridayData = async () => {
    try {
      const response = await api.get('/black_friday/active', {});

      if (response.data.data) {
        const responseBlackFriday = response.data.data.attributes;
        setBlackFriday({
          id: responseBlackFriday.id,
          dateStart: responseBlackFriday['date-start'],
          dateEnd: responseBlackFriday['date-end'],
          untilCountDown: responseBlackFriday['until-count-down'],
          active: responseBlackFriday.active,
        });
      } else {
        setBlackFriday(null);
      }
    } catch (_) {
      setBlackFriday(null);
    }
  };

  const getBlackFridayBannerFeature = async () => {
    try {
      const response = await fetchFeature('black_friday', true);
      if (response?.data) {
        const blackFridayFt =
          response?.data.some(
            (item) => item.attributes.key === 'black_friday' && item.attributes.active,
          ) || false;

        setFeatureIsActive(blackFridayFt);
      }
    } catch (_) {
      setFeatureIsActive(false);
    }
  };

  useEffect(() => {
    if (currentLanguage) {
      setLanguage(transcodeLanguage(currentLanguage));
    }
  }, [currentLanguage]);

  useEffect(() => {
    if (featureIsActive) {
      getBlackFridayData();
    }
  }, [featureIsActive]);

  useEffect(() => {
    getBlackFridayBannerFeature();
  }, []);

  const bannerData = useMemo(() => bannerBlackFridayData[language], [language]);

  return (
    !!blackFriday?.active &&
    featureIsActive && (
      <BannerWrapper className="show" id="banner">
        <ImageContainer left="-100px">
          <AnimationContainer>
            <AnimationCircle />
            <AnimationCircle withAnimation />
          </AnimationContainer>
          <BannerImage
            alt="Black Friday mLabs"
            title="logo-black-friday-mLabs"
            id="menu-logo"
            url={bannerData.logo}
            src={brandLogo}
          />
        </ImageContainer>

        <ContainerTexts>
          <Title dangerouslySetInnerHTML={{ __html: bannerData.title }} />
          <Disclaimer dangerouslySetInnerHTML={{ __html: bannerData.disclaimer }} />
        </ContainerTexts>
        <BorderBlackFriday src={BorderBlackFridayImage} alt="Border Black Friday" />
      </BannerWrapper>
    )
  );
};

export default BlackFriday;
